export const upperCaseFirst = (str?: string | null): string =>
	str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

export const stringTrim = (str?: string | null) => (str ? str.trim() : "");
